import React from 'react';

import { GameScoreModel } from '../../models/gameScoreModel';
import formatDateTimeString from '../../utils/Dates';

import './GameScore.scss';

interface Props {
  gameScore: GameScoreModel;
}

const GameScore = ({ gameScore: { score, total, createdAt } }: Props): React.ReactElement => (
  <div className="game-score">
    <div className="game-score-date">
      {formatDateTimeString(createdAt as string)}
    </div>

    <div className="game-score-score">
      {`${score} / ${total}`}
    </div>
  </div>
);

export default GameScore;
